// @flow
import * as React from 'react';
import IntlProvider from './IntlProvider';
import { Provider as ReduxProvider } from 'react-redux';

type Props = {|
    children: React.Node,
    store: any,
|};
const Provider = ({ children, store }: Props) => (
    <ReduxProvider store={store}>
        <IntlProvider>{children}</IntlProvider>
    </ReduxProvider>
);

export default Provider;
